export const REDUCER_NAME = "matchStatistics";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_MATCHSTATISTICS = `${REDUCER_NAME}/SET_MATCHSTATISTICS`;
export const RESET_MATCHSTATISTICS = `${REDUCER_NAME}/RESET_MATCHSTATISTICS`;

export const getKey = (data) => `${data.matchId}`;
